<template>
<svg
  :width="width"
  :height="height"
  viewBox="0 0 50 50"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  :id="iconName"
>
    <title v-if="iconName" :id="iconName">{{iconName}}</title>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="RetVejkode-UI-elementer" transform="translate(-1059.000000, -1946.000000)">
            <g id="Group-11" transform="translate(1059.000000, 1946.000000)">
                <rect id="Rectangle" stroke="#EBEDF5" fill="#FFFFFF" x="0.5" y="0.5" width="49" height="49" rx="2"></rect>
                <g id="Group-5" transform="translate(13.000000, 14.000000)">
                    <rect id="Rectangle" fill="#8954BA" x="0" y="0" width="24" height="23" rx="1"></rect>
                    <text id="NR" font-family="OpenSans-Semibold, Open Sans" font-size="10" font-weight="500" fill="#FFFFFF">
                        <tspan x="5" y="15">NR</tspan>
                    </text>
                </g>
            </g>
        </g>
    </g>
</svg>
</template>

<script>
export default {
  props: {
    iconName: String,
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
  },
};
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -2px;
}
</style>
